module.exports = __webpack_public_path__ + "img/jeff lynn scan_0001_stitch.9580094c.jpg";